import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import DataTable from "examples/Tables/DataTable";
import ordersDetailsTableData from "./ordersDetailsTableData";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import MDTypography from "components/MDTypography";
import { PrimaryColor } from "assets/theme/base/themeColors";

export default function OrdersDetailsDialog({ open, onClose, orderStore, loading }) {
  console.log("orderStore are in dialog: ", orderStore);
  // استخراج المنتجات من أول عنصر في order_store
  const items = orderStore?.order_store?.[0]?.items || [];
  const tableData = items.length ? ordersDetailsTableData(items) : { columns: [], rows: [] };
  const theme = useTheme();

  // حساب الإجماليات
  const totalProducts = items.length;
  const totalQuantity = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  const totalPrice = items.reduce((sum, item) => sum + Number(item.total_price || 0), 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        تفاصيل المنتجات في الطلب
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ textAlign: "center", padding: 40 }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <DataTable
              table={tableData}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
            {/* ملخص أسفل الجدول */}
            <Box
              mt={4}
              p={2}
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={6}
              sx={{
                background: PrimaryColor,
                borderRadius: 2,
                color: "white !important",
              }}
            >
              <MDTypography variant="h6" fontWeight="bold">
                إجمالي المنتجات: {totalProducts}
              </MDTypography>
              <MDTypography variant="h6" fontWeight="bold">
                إجمالي الكمية: {totalQuantity}
              </MDTypography>
              <MDTypography variant="h6" fontWeight="bold">
                إجمالي السعر: {totalPrice}
              </MDTypography>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
